import { FunctionComponent } from 'react';
import { SocialIcons } from '../../../../components/index';

export const Footer: FunctionComponent = () => {
    return (
        <div>
            <SocialIcons style={{ width: 'min-content', margin: '15px auto' }} />
            <span style={{ textAlign: 'center', display: 'block', padding: '10px' }}>
                Made with{' '}
                <span role="img" aria-label="Heart emoji">
                    ❤️
                </span>{' '}
                in Edinburgh{' '}
                <span role="img" aria-label="Scotland flag">
                    🏴󠁧󠁢󠁳󠁣󠁴󠁿
                </span>
            </span>
        </div>
    );
};
